import React from 'react';
import GamingChatbot from './components/GamingChatbot';
import './App.css';

function App() {
  return (
    <div className="App">
      <GamingChatbot />
    </div>
  );
}

export default App;
